















































































































































































import moment from "moment";
import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import MaintenanceTable from "./MaintenanceTable.vue";
import { DeviceServiceProxy } from "@/service-proxies/app-v2/workStation.service-proxies";
import {
  MaintainItemServiceProxy,
  MaintainPlanServiceProxy,
} from "@/service-proxies/app-v2/tpm.service-proxies";
import dayjs from "dayjs";
import { CodeRuleServiceProxy } from "@/service-proxies/app-v2/code.service-proxies";
const mpsp = new MaintainPlanServiceProxy();
const misp = new MaintainItemServiceProxy();
const dsp = new DeviceServiceProxy();
const csp = new CodeRuleServiceProxy();
export default Vue.extend({
  data() {
    return {
      codeRuleId: "",
      recordPlanList: [],
      show: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
      form: this.$form.createForm(this),
      loading: false,
      config: {
        rules: [
          {
            type: "object",
            required: true,
            message: this.$t("page_plan_maintenance_select_time"),
          },
        ],
      },
      deviceList: [],
      selectDevice: {},
      dataSource: [],
      count: 0,
      maintainItemList: [],
    };
  },
  components: {
    MaintenanceTable,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          dsp.getDeviceList().then((res) => {
            this.deviceList = res;
          });
          misp.queryMaintainItemList("").then((res) => {
            this.maintainItemList = res;
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    csp.list("MaintainPlanObject").then((res) => {
      this.recordPlanList = res;
    });
  },
  methods: {
    changeRecordPlan(val) {
      this.codeRuleId = val;
      if (val) {
        this.show = true;
       this.form.setFieldsValue({code:''})
      } else {
        this.show = false;
      }
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().startOf("day");
    },
    dayTime(value) {
      return dayjs(value).format("YYYY-MM-DD HH:mm:ss");
    },
    handleChangeDevice(value) {
      this.selectDevice = this.deviceList.find((res) => res.code === value);
    },
    reset() {
      this.form.resetFields();
      this.dataSource = [];
      this.count = 0;
      this.selectDevice = {};
    },
    close() {
      this.reset();
      this.$emit("close");
    },
    save() {
      this.form.validateFields((err, values) => {
        if (!err) {
          Object.keys(values).forEach((key) => {
            const item = values[key];
            values[key] =
              values[key] && typeof item == "string"
                ? values[key].replace(/\s*/g, "")
                : values[key];
          });
          const maintainItemList = JSON.parse(JSON.stringify(this.dataSource));
          const list = [];
          const canSave = true;
          maintainItemList.forEach((res) => {
            if (res.id) {
              const value = {
                itemId: res.id,
                projectId: "",
              };
              list.push(value);
            }
          });
          if (list.length < 1) {
            this.$message.warning(
              this.$t("page_plan_maintenance_please_add_program")
            );
            return;
          }
          if (list && list.length > 0) {
            values.maintainItemList = list;
            values.deviceId = this.selectDevice.workStationId;
            values.deviceName = this.selectDevice.name;
            values.deviceTypeId = this.selectDevice.deviceTypeId;
            values.deviceTypeName = this.selectDevice.deviceTypeName;
            values.codeRuleId = this.codeRuleId;

            values.maintainDate = dayjs(values.maintainDate).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            this.loading = true;
            mpsp
              .createMaintainPlan(values)
              .then(() => {
                this.$message.success(this.$t("create_success"));
                this.reset();
                this.$emit("reload");
                this.loading = false;
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    },
    onDelete(key) {
      const dataSource = [...this.dataSource];
      this.dataSource = dataSource.filter((item) => item.key !== key);
    },
    handleAdd() {
      const { count, dataSource } = this;
      const newData = {
        key: count,
        code: "",
        name: "",
        requirement: "",
        remark: "",
      };
      this.dataSource = [...dataSource, newData];
      this.count = count + 1;
    },
    handleChange(value, key) {
      const has = this.dataSource.find((res) => res.code === value);
      if (has != undefined) {
        this.$message.warning(this.$t("page_plan_maintenance_not_choose_same"));
        return;
      }
      const newData = [...this.dataSource];
      const target = newData.filter((item) => key === item.key)[0];
      const data = this.maintainItemList.find((res) => res.code === value);
      if (target && data) {
        target["id"] = data.id;
        target["code"] = value;
        target["name"] = data.name;
        target["requirement"] = data.requirement;
        target["remark"] = data.remark;
        this.dataSource = newData;
      }
    },
  },
});
